import type { AvatarImageProps, AvatarRootProps } from '@base-ui/react';
import type { ComponentPropsWithRef } from 'react';

import { Avatar as BaseAvatar } from '@base-ui/react';
import { assignInlineVars } from '@vanilla-extract/dynamic';

import { clsx, clsxs } from '~/styles/utils';

import { Icon } from '../Icon/Icon';
import { avatarGroupStyle, avatarShapeStyles, avatarSize, avatarStyle, fallbackRootStyle, fallbackStyle, imageStyle } from './Avatar.css';

type Props = AvatarRootProps & {
  fallback?: string;
  shape?: 'circle' | 'square';
  size?: number;
  src?: AvatarImageProps['src'];
};

type AvatarGroupProps = ComponentPropsWithRef<'div'>;

export const Avatar = ({ fallback, shape = 'circle', size = 48, src, ...delegated }: Props) => {
  return (
    <BaseAvatar.Root
      {...delegated}
      className={clsxs(
        avatarStyle,
        avatarShapeStyles[shape],
        (state) => state.imageLoadingStatus !== 'loaded' && fallbackRootStyle,
        delegated.className,
      )}
      style={{ ...assignInlineVars({ [avatarSize]: `${size}px` }), ...delegated.style }}
    >
      {src && <BaseAvatar.Image className={imageStyle} src={src} />}

      <BaseAvatar.Fallback className={fallbackStyle}>
        {fallback ?? <Icon name="Person" size={Math.min(Math.round(size * 0.35 + 12), size - 4)} />}
      </BaseAvatar.Fallback>
    </BaseAvatar.Root>
  );
};

export const AvatarGroup = ({ children, ...delegated }: AvatarGroupProps) => {
  return (
    <div {...delegated} className={clsx(avatarGroupStyle, delegated.className)}>
      {children}
    </div>
  );
};
